import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';
import { useQueryParams } from '@/hooks';
import { SortEnum } from '@/enums';
import {
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenu,
  TableHead,
  Button
} from '@/components/ui';
import { cn } from '@/lib/utils';

type TProps = {
  className?: string;
  name: string;
  text: string;
  classNameContent?: string;
}

export const TableHeadSortable = ({ text, className, name, classNameContent }: TProps) => {

  const { values: [sortType, sortBy], setValues } = useQueryParams(['sortType', 'sortBy']);

  const Icon = (
    (sortBy === name && sortType?.toUpperCase() === SortEnum.ASC)
      ? ArrowUp
      : (sortBy === name && sortType?.toUpperCase() === SortEnum.DESC)
        ? ArrowDown
        : ChevronsUpDown
  );

  const changeSort = (sortType: SortEnum) =>
    setValues({ sortType, sortBy: name });

  const isRightAligned = className?.includes('text-right');

  return (
    <TableHead className={cn(className, isRightAligned && "flex justify-end")}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            className={cn(
              'space-x-2',
              isRightAligned ? '-mr-3' : '-ml-3',
              classNameContent
            )}
            variant='ghost'
            size={'sm'}
          >
            <span>
              {text}
            </span>
            <Icon
              size={16}
              className={
                sortBy === name
                  ? 'text-purple-600'
                  : 'text-neutral-400'
              } />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className='w-32' align='end'>
          <DropdownMenuGroup>
            <DropdownMenuItem
              className='cursor-pointer'
              onClick={() => changeSort(SortEnum.ASC)}>
              <ArrowUp className='text-neutral-400' />
              <span>Asc</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className='cursor-pointer'
              onClick={() => changeSort(SortEnum.DESC)}>
              <ArrowDown className='text-neutral-400' />
              <span>Desc</span>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </TableHead>
  );

};

export default TableHeadSortable;
